<template>
  <el-dialog :visible.sync="showDialog" :title="title" :width="width" @close="cancel">
    <div class="clipBox">
      <div class="imgBox">
        <img id="cropImg" v-if="isHasImg" />
        <div class="addImg" v-else>
          <i class="iconfont icon-guanbiicon" @click="upload"></i>
          <p @click="upload">点击上传</p>
          <p>支持jpg、png格式,大小不超过5M</p>
        </div>
      </div>
      <div class="preview">
        <div :class="['previewBox', { radiusBox: shape == 2 }]" :style="{
            width: imgSize.width + 'px',
            height: imgSize.height + 'px',
          }"></div>
        <p v-if="isPer">企业LOGO预览</p>
      </div>
    </div>
    <div class="handelBtn" slot="footer">
      <input class="inpuFile" ref="inpuFile" type="file" accept=".jpg,.gif,.png" id="imgReader" value="上传图片" @change="loadingImg" />
      <el-button v-if="isShowReset" class="resetUpload" @click="upload">重新上传</el-button>
      <div>
        <el-button @click="cancel">取消</el-button>
        <el-button @click="save" type="primary" :disabled="isDisabled">保存</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";
// 上传模块
import { fileAstrict, uploadFile } from "../../tool/upload";
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "提示",
    },
    // 图片预览尺寸
    imgSize: {
      type: Object,
      default: () => {
        return {
          width: 112,
          height: 112,
        };
      },
    },
    shape: {
      type: Number,
      default: 1, // 1 方形 2 圆形
    },
    isPer: {
      type: Boolean,
      default: false, // 是否有图片预览说明
    },
    width: {
      type: String,
      default: "368px",
    },
  },
  data() {
    return {
      showDialog: false,
      CROPPER: null, // 图片裁切实例对象
      isShowReset: false,
      isDisabled: false,
      name: "", // 文件名
      isHasImg: false, // 是否有选择图片
    };
  },
  watch: {
    show(val) {
      this.showDialog = val;
    },
  },
  methods: {
    // 取消上传图片
    cancel() {
      this.$emit("update:show", false);
      this.isDisabled = false;
      this.isShowReset = false;
      this.isHasImg = false;
      if (this.CROPPER) {
        this.CROPPER.destroy();
        this.$refs["inpuFile"].value = null;
        this.isHasImg = false;
      }
    },
    // 上传图片
    upload() {
      // 重置新上传销毁实例
      if (this.CROPPER) {
        this.CROPPER.destroy();
        this.CROPPER = null;
        this.$refs["inpuFile"].value = null;
        this.isHasImg = false;
      }
      this.$refs["inpuFile"].click();
    },
    // 读取图片后
    async loadingImg(event) {
      if (event.target.files.length === 0) {
        this.isShowReset = false;
        return;
      }
      //读取上传文件
      let reader = new FileReader();
      if (event.target.files[0]) {
        let isPass = await fileAstrict(
          event.target.files[0],
          [".jpg", ".png", ".gif"],
          5
        );
        if (!isPass) return;
        this.name = event.target.files[0].name;
        this.isHasImg = true;
        this.isShowReset = true;
        //readAsDataURL方法可以将File对象转化为data:URL格式的字符串（base64编码）
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = () => {
          let dataURL = reader.result;
          //将img的src改为刚上传的文件的转换格式
          document.querySelector("#cropImg").src = dataURL;
          const image = document.getElementById("cropImg");
          //创建cropper实例-----------------------------------------
          this.CROPPER = new Cropper(image, {
            aspectRatio: this.imgSize.width / this.imgSize.height,
            viewMode: 0,
            minContainerWidth: 310,
            minContainerHeight: 310,
            dragMode: "move",
            preview: [document.querySelector(".previewBox")],
          });
        };
      }
    },
    // 上传方法
    async uploadDispose(blob) {
      blob.name = this.name;
      // 获取图片路径
      const data = await uploadFile(blob, "headImg", true);
      if (data.status) {
        this.$message({
          type: "success",
          message: "修改成功",
        });
        this.$emit("save", data);
      } else {
        this.$message({
          type: "error",
          message: data.message,
        });
      }
      this.cancel();
    },
    // 保存
    save() {
      if (this.CROPPER) {
        this.isDisabled = true;
        //getCroppedCanvas方法可以将裁剪区域的数据转换成canvas数据
        this.CROPPER.getCroppedCanvas({
          maxWidth: 4096,
          maxHeight: 4096,
          // fillColor: '#fff',
          imageSmoothingEnabled: true,
          imageSmoothingQuality: "high",
        }).toBlob(
          (blob) => {
            //然后调用浏览器原生的toBlob方法将canvas数据转换成blob数据
            console.log(blob);
            this.uploadDispose(blob);
          },
          "image/png",
          1
        );
      }
    },
  },
};
</script>

<style lang="scss">
.clipBox {
  padding-top: 14px;
  display: flex;
}
.inpuFile {
  display: none;
}
.imgBox {
  position: relative;
  width: 310px;
  height: 310px;
  background: #f9fafe;
  border-radius: 4px;
  border: 1px dashed #dcdee0;
  .addImg {
    position: absolute;
    text-align: center;
    width: 100%;
    top: 105px;
    & > i {
      display: inline-block;
      font-size: 26px;
      transform: rotate(45deg);
      cursor: pointer;
      color: #cccccc;
    }
    p {
      margin-top: 10px;
      line-height: 22px;
      &:nth-child(2) {
        color: #646566;
        font-size: 16px;
        cursor: pointer;
      }
      &:nth-child(3) {
        font-size: 13px;
        color: #999999;
      }
    }
  }
}
#cropImg {
  width: 100%;
  height: 100%;
}
.preview {
  margin-left: 24px;
  text-align: center;
  p {
    margin-top: 16px;
  }
}
.previewBox {
  border: 1px solid #e8e8eb;
  overflow: hidden; /*这个超出设置为隐藏很重要，否则就会整个显示出来了*/
}
.radiusBox {
  border-radius: 50%;
}
.handelBtn {
  position: relative;
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;
  .el-button {
    border-radius: 2px;
    padding: 11px 23px;
    font-weight: 400;
    font-family: PingFangSC, PingFang SC;
  }
  .resetUpload {
    position: absolute;
    left: 0;
    padding-left: 39px;
    padding-right: 39px;
  }
}
</style>
